import { atom } from 'jotai'

interface OrderIdAtom {
  key: string
  properties: string[]
  orders: string[]
}

export interface ISelectedOrderRow {
  id: string
  supplier_id?: string
  factory_id?: string
  property_values?: { field: string, value: string }[]
  aql?: string
  aql_id?: string
  is_delivered?: boolean
}

export const inspectionSelectionAtom = atom<ISelectedOrderRow[]>([])
export const pbfOrderAtom: any = atom(null)

export const orderIdAtom = atom<OrderIdAtom>({
  key: '',
  properties: [],
  orders: [],
})

export const massUpdateAtom = atom(true)

export const selectedTemplateAtom: any = atom(null)

export const orderCompanyIdAtom: any = atom(null)

export const orderCreationTabNumberAtom: any = atom('1')
